import React, { Component } from 'react';
import styled from 'styled-components';
import autoComplete  from '../assets/javascript/autocomplete.js';
import breakpoints from "../styles/breakpoints";
import Container from "./Core/Container";
import Section from "./Core/Section";

//css 
import '../assets/styles/calender.css';
import '../assets/styles/autocomplete.css';
import Litepicker from  '../assets/javascript/litepicker.js';

//funcitons
import getCookie from '../functions/getCookie.js';

const Styles = styled.div`
    .hth {
        height: auto;
        background: var(--primary);
        padding: 1rem 0;
        width: 100%;
        box-sizing: border-box;
        text-align: left;

        &.hero {
            padding: 1rem;
            border-radius: .25rem;
            margin: auto;
            background: none;
        }

        .copy-container {
            margin: 0 0 1.5rem;
            color: var(--black);

            &.white {
                color: var(--white);
            }

            &--margin {
                margin: 0 0 3.125em;
            }
        }

        .heading {
            font-weight: 700;
            font-size: 1.5rem;
            margin: 0;
        }

        .tagline, .description {
            font-size: .875rem;
            margin: 1rem 0 0;
        }

        .fcon {
            display: flex;
            flex-direction: column;
        }

        .drop {
            position: relative;
        }

        .inner {
            height: 3.5rem;
            line-height: 3.5rem;
            background: #fff;
            border-radius: 0.313em;
            margin: 0.625rem 0 0 0;
            width: 100%;
            box-sizing: border-box;
            border: none;
            display: flex;
            flex-direction: column;
            position: relative;

            .date {
                cursor: pointer;
            }

            label {
                height: 1rem;
                font-size: 0.875rem;
                padding: .5rem 1rem 0;
                font-weight: 700;
                position: absolute;
                top: -1.313rem;
                pointer-events: none;
                color: #000;
            }

            input {
                line-height: 30px;
                border-radius: 15px;
                width: 100%;
                padding: 21px 16px 0;
                box-sizing: border-box;
                background: transparent;
                border: none;

                &:focus {
                    outline: none;
                }
            }

            select {
                line-height: 30px;
                border-radius: 15px;
                width: 100%;
                padding: 21px 16px 0;
                box-sizing: border-box;
                background: transparent;
                border: none;
                cursor: pointer;
                -webkit-appearance: none;
                -moz-appearance: none;
                appearance: none;
                color: black;

                &:focus {
                    outline: none;
                }
            }
        }

        .inner.region_box {
            margin: 0;

            input {
                padding: 1.313rem 2.813rem 0 1rem;
            }
        }

        .search_box {
            min-height: 3.5rem;

            .submit {
                height: 3.5rem;
                width: 100%;
                margin: 0;
                border: none;
                padding: 0;
                background: var(--secondary);
                color: #fff;
                font-weight: 700;
                cursor: pointer;
                border-radius: .313rem;

                &:hover,
                &:focus {
                    background: var(--lightenButton);
                    transition: .3s;
                }
            }
        }

        .hth-mobile-cal {
            height: 100%;
            position: relative;
            max-height: max-content;
            overflow: visible;
        }

        ul {
            list-style: none;
        }

        .close {
            height: 1.063rem;
            width: 0.813rem;
            position: absolute;
            right: 1.563rem;
            bottom: 2rem;
            cursor: pointer;
            z-index: 10;
        }

        .close.hide {
            display: none;
        }

        .foot {
            display: flex;
            margin: 10px 0 0 0;
            flex-direction: column;
            align-items: center;

            .checkbox-block {
                width: 100%;
                display: flex;
                grid-row-gap: .625rem;
                flex-direction: column;
            }

            .snaptrip_box {
                display: flex;
                align-items: center;
                margin: 10px 0 0 0;

                svg {
                    width: 50px;
                }
            }

            .hottub_box, .lr-box {
                display: flex;
                align-items: center;
            }

            p {
                color: #000;
                font-size: 12px;
                margin: 0 6px 0 0;
                display: flex;
                white-space: nowrap;

                &.white {
                    color: #fff;
                }

            }

            label {
                color: #000;
                font-size: 12px;
                margin-left: 6px;
                cursor: pointer;
                user-select: none;
                padding-top: 3px;

                &.white {
                    color: #fff;
                }
            }

            input {
                display: none;

                &:checked {
                    + {
                        .checkbox {
                            svg {
                                display: block;
                            }

                            background: var(--secondary);
                        }
                    }
                }
            }

            .checkbox {
                height: 18px;
                width: 18px;
                background: #eeeeee;
                border-radius: 50%;
                cursor: pointer;
                display: flex;
                justify-content: center;
                align-items: center;

                svg {
                    height: 12px;
                    width: 12px;
                    fill: var(--primary);
                    display: none;
                }
            }
        }

        .hth-mobile {
            display: flex;

            .inner {
                width: calc(50% - 5px);

                &:first-of-type {
                    margin-right: 10px;
                }
            }
        }

        #autofill {
            position: relative;
            z-index: 10;
        }

        .autocomplete-suggestion {
            position: relative;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            color: #333;
            font-size: 14px;
            background: #eee;
            padding: 16px 16px 2px 16px;
            cursor: pointer;
            line-height: 1.25;
            margin-top: -1px;

            &:last-of-type {
                padding: 16px;
                border-bottom-left-radius: 15px;
                border-bottom-right-radius: 15px;
            }

            &:hover {
                color: var(--primary);

                .sub-region {
                    color: var(--primary);
                }
            }
        }

        .autocomplete-suggestion.selected {
            color: var(--primary);

            .sub-region {
                color: var(--primary);
            }
        }
    }

    @media only screen and (min-width: 600px) {
        .hth {
            padding: 1.25rem 0;

            &.hero {
                padding: 1.25rem;
            }

            .foot {
                justify-content: space-between;
                flex-direction: row;
                align-items: center;

                .snaptrip_box {
                    margin: 0;
                }
            }
        }
    }

    @media only screen and (min-width: ${breakpoints.lg}) {
        .hth {
            width: 100%;

            &.hero {
                background: var(--primary);
            }

            .foot {
                .checkbox-block {
                    grid-row-gap: 0;
                    width: max-content;
                    flex-direction: row;
                    grid-column-gap: 1.25rem;
                }
            }

            .fcon {
                flex-direction: row;
            }

            .inner.region_box {
                input {
                    padding: 21px 45px 0 16px;
                }
            }

            .inner {
                margin: 0 0 0 10px;
            }

            .hth-mobile {
                flex-direction: row;
                background: none;
                width: 100%;

                .inner {
                    width: 50%;

                    &:first-of-type {
                        margin-right: 0;
                    }
                }
            }
        }
    }


`;

const ScrollButton = styled.button`
    position: fixed;
    bottom: 1rem;
    right: 1.25rem;
    box-shadow: 0 0 1.25rem rgb(0 0 0 / 30%);
    z-index: 100;
    height: 3rem;
    width: 3rem;
    border-radius: 50%;
    cursor: pointer;
    background-color: var(--secondary);
    border: none;

    svg {
        fill: white;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    span {
        display: none;
    }

    @media only screen and (min-width: ${breakpoints.lg}) {

        span {
            opacity: 0;
            display: inline;
            top: 1rem;
            transition: all ease .5s;
            position: absolute;
            color: #000;
            background: white;
            padding: 0.5rem 1rem;
            font-size: 0.65rem;
            width: 6.25rem;
            border-radius: 4px;
            right: 0;

            &::after {
                content: "";
                position: absolute;
                right: 18px;
                width: 0;
                height: 0;
                bottom: -7px;
                border-left: 7px solid transparent;
                border-right: 7px solid transparent;
                border-top: 7px solid #fff;
            }
        }

        &:hover,
        &:focus {

            span {
                top: -2rem;
                opacity: 1;
            }

        }
    }
`;

class SearchForm extends Component {
    constructor (params) {
        super(params)
        this.checkInRef = React.createRef()
        this.checkOutRef = React.createRef()
        this.regionRef = React.createRef()
        this.fixedRef = React.createRef()
    }

    state = {
        nights: "",
        checkout: "",
        datepicker: "",
        guests: "",
        region: "",
        date: "",
        heading: "",
        description: "",
        sortTest: false,
        hot_tub: !!this.props.hottubFilter,
        bcom: true,
        filters: {
            //property types
            apartment: !!this.props.apartmentFilter,
            cottage: !!this.props.cottageFilter,
            lodge: !!this.props.lodgeFilter,

            //filters
            beach: !!this.props.beachFilter,
            garden: !!this.props.gardenFilter,
            wifi: !!this.props.wifiFilter,
            parking: !!this.props.parkingFilter,
            baby: !!this.props.babyFilter,
            pool: !!this.props.poolFilter,
            fire: !!this.props.fireFilter,
            pet_count: this.props.petFilter ? 1 : false,

            //tag filters 
            tags: [
                this.props.luxuryFilter ? "luxury" : "",
                this.props.gamesFilter ? "games room" : "",
                this.props.enclosedFilter ? "enclosed garden" : "",
                this.props.pubFilter ? "pub" : "",
                this.props.secludedFilter ? "secluded" : "",
                this.props.accessibleFilter ? "accessible" : ""
            ]
        }
    };

    changeRegion = (event) => {
        this.setState({region: event.target.value});
    }

    changeDate = (event) => {
        this.setState({date: event.target.value});
    }

    changeGuests = (event) => {
        this.setState({guests: event.target.value});
    }

    emptyRegion = () => {
        this.setState({region: ""});
        this.regionRef.current.focus();
    }

    checkHottub = (el) => {
        this.setState({hot_tub: !this.state.hot_tub});
    }

    compareBCom = () => {
        this.setState({bcom: !this.state.bcom});
    }

    ajaxRequest = (options, suCallback, erCallback) => {
        var xhr = new XMLHttpRequest(),
            status = typeof options.status !== "undefined" ? options.status : 200;
        xhr.open(options.type, options.url, true);
        xhr.setRequestHeader('Content-Type', options.header);
        if (typeof options.accept !== "undefined") {
            xhr.setRequestHeader('Accept', options.accept);
        }
        if (typeof options.auth !== "undefined") {
            xhr.setRequestHeader('Authorization', options.auth);
        }
        if (typeof options.custom !== "undefined") {
            xhr.setRequestHeader(options.custom[0], options.custom[1]);
        }
        xhr.setRequestHeader('X-CSRF-Token', options.csrf);
        xhr.setRequestHeader('X-Requested-With', "XMLHttpRequest");

        xhr.timeout = 3000;
        xhr.ontimeout = function() {
            if (typeof erCallback !== 'undefined') {
                erCallback({ error: 'Request timed out' });
            }
        };

        xhr.onreadystatechange = function () {
            var response;
            if (xhr.readyState === 4 && xhr.status === status) {
                response = options.dataType === "json" ? JSON.parse(xhr.responseText) : xhr.responseText;
                if (typeof suCallback !== 'undefined') {
                    suCallback(response);
                }
            } else if (xhr.readyState === 4 && (xhr.status === 500 || xhr.status === 404 || xhr.status === 400)) {
                if (typeof erCallback !== 'undefined') {
                    erCallback(xhr);
                }
            }
        };
        xhr.send(options.data);
    }

    openDatepicker = () => {
        var app = this;
        app.state.datepicker.show();
    }

    conductSearch = (event) => {
        event.preventDefault();

        let thisFriday = new Date();
        const day = thisFriday.getDay();
        const targetDay = 5;  // Friday
        let dayOffset = targetDay - day;
        if (dayOffset < 0) dayOffset += 7;

        thisFriday = new Date(thisFriday.getTime() + (dayOffset * 24 * 3600 * 1000));

        let thisMonday = new Date(thisFriday);
        let numberOfDayToAdd = 3;
        thisMonday.setDate(thisMonday.getDate() + numberOfDayToAdd );

        if (!this.state.nights) {
            if (!this.state.date){
                this.setState({date: String(thisFriday).split(' ').slice(0, 4).join(' ')});
                this.setState({checkout: String(thisMonday).split(' ').slice(0, 4).join(' ')});
            } else if (this.state.date) {
                let datePlusThreeNights = new Date(this.state.date);
                datePlusThreeNights.setDate(datePlusThreeNights.getDate() + 3);
                this.setState({checkout: String(datePlusThreeNights).split('00:00:00')[0]});
            }
            this.setState({nights: 3})
        }

        setTimeout(() => {
            this.dataLayerPush("outbound-search", "snaptrip search");
            if (this.state.bcom) {
                this.dataLayerPush("outbound-search", "booking.com search");
            }
            this.createUrl();
        }, 50);
    }

    createUrl = () => {
        let app = this.state;
        let filters = app.filters;
        let utmParams = "&utm_medium=referral";
        const trackingProfileId = getCookie('tracking_profile_id');

        //remove blank values from tags array 
        let filteredTags = filters.tags.filter(function (el) {
            return el != "";
        });

        let url = `https://www.snaptrip.com/searches/custom?search[region]=${app.region}&search[check_in_on]=${app.date.replace(/ /g, '%20')}&search[minimum_nights]=${app.nights}&search[sleeps]=${app.guests ? app.guests : '1'}${ filteredTags.length ? '&search[tags]=' + filteredTags.join(',').replace(/ /g, '%20') : ""}`;

        //loop over filter obj
        for (const property in app.filters) {
            if (app.filters[property] && property !== "tags") {
                url = url + `&search[${property}]=${app.filters[property]}`;
            }
        }

        //if ppc we want to add the gclid from google through to ST as a url param
        //we also want to add any utm params coming from google such as utm_term, utm_campaign etc.

        //gclid
        let gclid = location.href.includes("gclid=") ? "gclid=" + location.href.split("gclid=")[1]: "";
        gclid = gclid.includes("&") ? gclid.split('&')[0] : gclid;
        gclid ?  utmParams = utmParams + '&' + gclid : "";
        
        //msclkid
        let msclkid = location.href.includes("msclkid=") ? "msclkid=" + location.href.split("msclkid=")[1]: "";
        msclkid = msclkid.includes("&") ? msclkid.split('&')[0] : msclkid;
        msclkid ?  utmParams = utmParams + '&' + msclkid : "";
        
        //utm_source
        let source = location.href.includes("utm_source=") ? "utm_source=" + location.href.split("utm_source=")[1]: "";
        source = source.includes("&") ? source.split('&')[0] : source;
        source ?  utmParams = utmParams + '&' + source : utmParams = utmParams + "&utm_source=hottubhideaways";

        //utm_content
        let content = location.href.includes("utm_content=") ? "utm_content=" + location.href.split("utm_content=")[1]: "";
        content = content.includes("&") ? content.split('&')[0] : content;
        content ?  utmParams = utmParams + '&' + content : "";

        // for utm campaign we also want to include the landing page (the page the user has entered on)
        // and the leaving page (the current page url the user is leaving us from) and add it to the utm campaign 
        //utm_campaign
        let entryPage,
            exitPage;

        if (typeof window !== "undefined") {
            entryPage = "https://www.hottubhideaways.com" + window.sessionStorage.getItem("landingUrl");
            exitPage = window.location.href;
        }

        let campaign = location.href.includes("utm_campaign=") ? "utm_campaign=" + location.href.split("utm_campaign=")[1]: "";
        campaign = campaign.includes("&") ? campaign.split('&')[0] : campaign;
        campaign ?  utmParams = utmParams + '&' + campaign : utmParams = utmParams + `&utm_campaign=searchform-Unlabelled-landing-${entryPage}-click-${exitPage}`;

        //hottubs 
        if (app.hot_tub) {
            url = url + `&search[hot_tub]=true`;
        }
        this.openInNewTab(url + utmParams);

        let bcUrl;

        if (this.state.bcom) {
            let checkIn = new Date(this.state.date);
            let formattedCheckIn = checkIn.toLocaleDateString('en-CA');
            let checkOut = new Date(this.state.checkout);
            let formattedCheckOut = checkOut.toLocaleDateString('en-CA');
            let filtersUrl = "";

            this.state.filters.apartment ? filtersUrl = filtersUrl + 'ht_id=201;' : null;
            this.state.filters.beach ? filtersUrl = filtersUrl + 'ht_beach=1;' : null;
            this.state.filters.cottage ? filtersUrl = filtersUrl + 'ht_id=220;' : null;
            this.state.filters.garden ? filtersUrl = filtersUrl + 'roomfacility=123' : null;
            this.state.filters.lodge ? filtersUrl = filtersUrl + 'ht_id=221;' : null;
            this.state.filters.parking ? filtersUrl = filtersUrl + 'hotelfacility=2;' : null;
            this.state.filters.pet_count ? filtersUrl = filtersUrl + 'hotelfacility=4;' : null;
            this.state.filters.pool ? filtersUrl = filtersUrl + 'hotelfacility=301;' : null;
            this.state.filters.wifi ? filtersUrl = filtersUrl + 'hotelfacility=107;' : null;

            filtersUrl.length > 0 ? filtersUrl = filtersUrl.replace(/=/g, '%3D').replace(/;/g, '%3B') : null;

            if (this.state.region && this.state.region.includes(",")) {
                const regions = ["England", "Scotland", "Wales"];
                for (let i = 0; i < regions.length; i++) {
                    if (this.state.region.includes(regions[i]) && !this.state.region.includes("United Kingdom")) {
                        this.state.region = this.state.region.replace(regions[i], "United Kingdom");
                        break;
                    }
                }
            }

            if (this.state.region) {
                let app = this;
                let regionParts = this.state.region.split(',')
                let cityName;
                let countryName;

                if (regionParts.length > 1) {
                  cityName = regionParts[0].trim();
                  countryName = regionParts[regionParts.length -1].trim()
                } else {
                  cityName = regionParts[0].trim();
                  countryName = "United Kingdom"

                    // Get correct dest_id and type for certain destinations on the nav,
                    if (cityName.toLowerCase().startsWith('the ')) {
                        cityName = cityName.substring(4).trim();
                    }

                    if (cityName.toLowerCase() === 'cotswolds') {
                        cityName = 'Cotswold'
                    }

                }

                //get dest_Id
                this.ajaxRequest({
                        url: "https://www.laterooms.com/2.5/json/autocomplete?language=en&text=" + encodeURIComponent(cityName + ',' + countryName),
                        type: "GET",
                        dataType: "json",
                    }, function(response) {
                        if (response.result.length > 0) {
                            // "222", "country" is fallback for "United Kingdom" search
                            const destId = response.result[0].id || "222";
                            const destType = response.result[0].type || "country";
                            bcUrl = `https://www.booking.com/searchresults.en.html?dest_id=${destId}&dest_type=${destType}${app.state.date ? `&checkin=${formattedCheckIn}` : ""}${app.state.date ? `&checkout=${formattedCheckOut}`: ""}&do_availability_check=1&order=popularity${app.state.guests ? "&group_adults=" + app.state.guests : ""}&nflt=roomfacility%3D14%3B${filtersUrl}&aid=338955&label=HTH-comparison-${trackingProfileId}-${gclid ? gclid : ''}`

                            app.openInSameTab(bcUrl)
                        } else {
                            let encodeRegion = region && encodeURIComponent(region);

                            bcUrl = encodeRegion ? `https://www.booking.com/searchresults.en.html?ss=${encodeRegion.replace(/%20/g, '+')}${app.state.date ? `&checkin=${formattedCheckIn}` : ""}${app.state.date ? `&checkout=${formattedCheckOut}`: ""}&do_availability_check=1&order=popularity${app.state.guests ? "&group_adults=" + app.state.guests : ""}&nflt=roomfacility%3D14%3B${filtersUrl}&aid=338955&label=HTH-comparison-${trackingProfileId}-${gclid ? gclid : ''}` : `https://www.booking.com/?&aid=338955&label=HTH-comparison-${trackingProfileId}-${gclid ? gclid : ''}`;

                            app.openInSameTab(bcUrl)
                        }
                    }, function(error) {
                        let encodeRegion = region && encodeURIComponent(region);

                        bcUrl = encodeRegion ? `https://www.booking.com/searchresults.en.html?ss=${encodeRegion.replace(/%20/g, '+')}${app.state.date ? `&checkin=${formattedCheckIn}` : ""}${app.state.date ? `&checkout=${formattedCheckOut}`: ""}&do_availability_check=1&order=popularity${app.state.guests ? "&group_adults=" + app.state.guests : ""}&nflt=roomfacility%3D14%3B${filtersUrl}&aid=338955&label=HTH-comparison-${trackingProfileId}-${gclid ? gclid : ''}` : `https://www.booking.com/?&aid=338955&label=HTH-comparison-${trackingProfileId}-${gclid ? gclid : ''}`;

                        app.openInSameTab(bcUrl)
                    })
            } else {
                let app = this;
                bcUrl = `https://www.booking.com/?&aid=338955&label=HTH-comparison-${trackingProfileId}-${gclid ? gclid : ''}${app.state.date ? `&checkin=${formattedCheckIn}` : ""}${app.state.date ? `&checkout=${formattedCheckOut}`: ""}`;

                app.openInSameTab(bcUrl)
            }
        }
    }

    openInSameTab = (url) => {
        window.open(url, '_self');
        window.location.href = url;
    }

    openInNewTab = (url) => {
        var win = window.open('/redirect?url=' + url, '_blank');
        if (win) {
            win.focus();
        }
    }

    formScroll = () => {
        let el;
        this.fixedRef ? el = this.fixedRef.current : '';

        //get screen width 
        let w = window.innerWidth;
        if (w > 1280 && el) {
            var diff = w - 1280;
            el.style.right = ((diff / 2) + 20) + 'px';
        } else if (el) {
            el.style.right = '1.25rem'
        }
        
    }

    scrollToform = () => {
        let el = this.regionRef.current;

        setTimeout(() => {
            if (typeof window !== `undefined`) {
                window.scrollTo({
                    top: el.getBoundingClientRect().top + window.pageYOffset,
                    behavior: 'smooth',
                });
            }
            el.focus();
          }, 50);
    }

    dataLayerPush = (outboundEvent, outbountURL) => {
        if (typeof window !== 'undefined'){
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({'event': outboundEvent,  'outbound-destination': outbountURL});

            if (this.state.lr) {
                dataLayer.push({'event': outboundEvent,  'outbound-destination': outbountURL});
            }
        }
    }

    checkForTest = () => {
        var app = this;
        if (typeof window !== "undefined") {
            //window.isTest = true;
            setTimeout(() => {
                if (window.isTest === true) {
                    app.setState({sortTest: true});
                }
            }, 100);
        }
    }

    // change the order of suggetsion lists
    sortSuggestionLists(response, term) {
        let matchedArray = [];
        let unmatchedArray = [];
        let newArray = [];
        let inputValue = term.toUpperCase();
        response.forEach(value => {
            let locationName = value.split(",")[0].toUpperCase();
            if (locationName.indexOf(inputValue) === 0) {
                matchedArray.push(value);
            } else {
                unmatchedArray.push(value);
            }
        });
        newArray = [...matchedArray, ...unmatchedArray];
        return newArray
    }

    componentDidMount () {
        let app = this;
        app.checkForTest();

        app.setState({heading: app.props.heading});
        app.setState({description: app.props.description});

        // check for override then apply it to the region/dates/nights/guests respectively
        if (app.props.override) {
            app.setState({region: app.props.override});
        }

        if (app.props.region) {
            app.setState({region: app.props.region});
        }

        if (app.props.overrideDate) {
            var d = new Date(app.props.overrideDate);
            app.setState({date: d.toString().split('01:00:00')[0]});
        }

        if (app.props.overrideNights) {
            app.setState({nights: app.props.overrideNights});
        }

        if (app.props.overrideGuests) {
            app.setState({guests: app.props.overrideGuests});
        }

        //check for location in order to build correctly on Server Side
        // ppc page only
        if (typeof location !== `undefined` && this.props.ppc) {
            var url = location.href;
            var region = url.includes("region=") ? location.href.split("region=")[1]: "";
            region = region.includes("&") ? region.split('&')[0] : region;
            region ? app.setState({region: decodeURI(region)}): null;
        }

        if (typeof window !== `undefined`) {

            window.addEventListener('scroll', this.formScroll);
            window.addEventListener('resize', this.formScroll);

            app.setState({datepicker: new Litepicker({
            element: app.checkInRef.current,
            elementEnd: app.checkOutRef.current,
            singleMode: false,
            autoRefresh: true,
            allowRepick: true,
            minDate: new Date() -1,
            numberOfColumns: 2,
            numberOfMonths: 2,
            minDays: 2,
            maxDays: 29,
            format: "D MMM YYYY", 
            tooltipText: {
              one: 'night',
              other: 'nights'
            },
            tooltipNumber: (totalDays) => {
              return totalDays - 1;
            },
            resetButton: () => {
                let btn = document.createElement('button');
                btn.innerText = 'Clear';
                btn.disabled = true;
                btn.setAttribute("id", 'clear-button');
                btn.setAttribute("class", "reset-button");

                btn.addEventListener('click', (evt) => {
                    evt.preventDefault();
                });

                return btn;
            },
            setup: (picker) => {

                let nav = document.getElementById('nav');

                picker.on('preselect', (date1, date2) => {
                    if (date1 && !date2) {
                        app.setState({date: date1.dateInstance.toString().split('00:00:00')[0]});
                        app.setState({checkout: ""});
                        document.getElementById('clear-button').disabled = false;
                    }
                    
                });

                picker.on('selected', (date1, date2) => {
                        var timeDiff = Math.abs(date2.dateInstance.getTime() - date1.dateInstance.getTime());
                        var numberOfNights = Math.ceil(timeDiff / (1000 * 3600 * 24));

                        setTimeout(() => {
                            app.setState({date: date1.dateInstance.toString().split('00:00:00')[0]});
                            
                            app.setState({nights: numberOfNights});
                            app.setState({checkout: date2.dateInstance.toString().split('00:00:00')[0]});
                        });
                        
                });

                picker.on('show', (el) => {
                    //add close button for mobile
                    var cal = picker.ui;
                    cal.insertAdjacentHTML('afterend', '<button class="litepicker-close">Close</button>');

                    if (innerWidth < 1025) {
                        document.body.style.overflow = "hidden";
                        document.body.style.position = "fixed";
                    }

                    //if you've clicked on the check out field, then the check in should remain the same and you should begin by editing the check out
                    if (el.id !== 'checkout' && app.state.date) {
                        picker.clearSelection(); 
                    }

                    //to do with toggling nav on mobiles
                    nav.dataset.show = true;
                    
                });

                picker.on('hide', () => {
                    document.querySelector('button.litepicker-close').remove();
                    document.body.style.overflow = "auto";
                    document.body.style.position = "relative";
                    nav.dataset.show = false;
                });
            
            }
          })
        });
        }

        new autoComplete({
            selector: app.regionRef.current,
            minChars: 3,
            cache: false,
            source: function (term, suggest) {
                app.ajaxRequest({
                    url: "https://www.snaptrip.com/searches/autocomplete?query=" + term,
                    type: "GET",
                    dataType: "json"
                }, function (response) {
                    let newResponse = app.sortSuggestionLists(response, term)                                
                    suggest(newResponse);
                });
            },
            renderItem: function(item, search) {
                search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
                var re = new RegExp("(" + search.split(' ').join('|') + ")", "gi");
                if(item.includes(",")){
                    return '<div class="autocomplete-suggestion" data-val="' + item + '">' + item.replace(re, "<b>$1</b>").replace(",", "+").split("+")[0] + '<br /><span class="sub-region">' + item.replace(re, "<b>$1</b>").replace(",", "+").split("+")[1]  + '</span></div>';
                } else {
                    return '<div class="autocomplete-suggestion" data-val="' + item + '">' + item.replace(re, "<b>$1</b>") + '</div>';
                }
            },
            onSelect: function (e, term, item) {
                e.preventDefault();
                app.setState({region: term});
            }
        });
    }

    componentWillUnmount() {
        if (typeof window !== `undefined`) {
            window.removeEventListener('scroll', this.formScroll);
            window.removeEventListener('resize', this.formScroll);
        }
    }

    render() {
        let showCopy = (this.props.heading || this.props.tagline || this.props.description);

        let guestsArr = [];
        for (let i = 1; i <= 10; i++) {
            guestsArr.push(i);
        }

        return (
            <Section id={this.props.id ? this.props.id : null}>
            <Styles>
                <div className={`hth ${this.props.hero ? "hero" : ""}`} id="search-form">
                    <Container fullWidthMobile={this.props.fullWidthMobile}>
                    { showCopy ? <div className={`copy-container ${this.props.color ? "white" : ""}`}>
                            {this.props.heading && !this.props.property ? <h1 className="heading">{this.state.heading ? this.state.heading : this.props.heading}</h1> : null}
                            {this.props.heading && this.props.property ? <h2 className="heading">{this.state.heading ? this.state.heading : this.props.heading}</h2> : null}
                            {this.props.tagline && <p className="tagline">{this.props.tagline}</p>}
                            {this.props.description && <p className="description">{this.state.description ? this.state.description : this.props.description }</p>}
                    </div> : null}
                    <form onSubmit={this.conductSearch}>
                        <div className="fcon">
                            <div className="inner region_box">
                                <label htmlFor="region">Destination</label>
                                <input id="region" ref={this.regionRef} value={this.state.region}  className="region" name="region" type="text" placeholder="Where are you travelling?" autoComplete="off" onChange={this.changeRegion}/>
                                { this.state.region && <div className="ico close" onClick={this.emptyRegion}>✕</div> }
                                <ul className="drop">
                                    <li id="autofill"/>
                                </ul>
                            </div>
                            <div className="hth-mobile hth-mobile-ca">
                                <div className="inner date_box">
                                    <label htmlFor="date">Check in*</label>
                                    <input id="date" ref={this.checkInRef} name="d8" placeholder="Add dates" readOnly value={this.state.date} type="text" className="date" autoComplete="off" />
                                </div>
                                <div className="inner date check-out" >
                                    <label htmlFor="checkout">Check out*</label>
                                    <input className="date" ref={this.checkOutRef} name="checkout" readOnly value={this.state.checkout} type="text" autoComplete="off" id="checkout" placeholder="Add dates" />
                                </div>
                            </div>
                            <div className="hth-mobile">
                                <div className="inner guest_box">
                                    <label htmlFor="guests">Guests</label>
                                    <select name="guests" id="guests" className="date long" onChange={this.changeGuests} value={this.state.guests}>
                                        <option className="disabled" value="" disabled >Add guests</option>
                                        {guestsArr.map((index) => {
                                            return <option value={index} key={index}>{index}+ Guest{ index > 1 ? 's' : ''}</option>
                                        })}
                                    </select>
                                </div>
                                <div className="inner search_box">
                                    <button className="submit">Search</button>
                                </div>
                            </div>
                        </div>
                    </form>
                    <div className="foot">
                        <div className="checkbox-block">
                            <div className="lr-box" onClick={this.compareBCom}>
                                <input id="lr" type="checkbox" name="lr" checked={this.state.bcom} readOnly/>
                                <span className="checkbox">
                                <svg viewBox="0 0 512 512">
                                    <path d="m187 434l-173-166 48-47 125 120 263-252 48 46z"></path>
                                </svg>
                            </span>
                                <label htmlFor="hottub" className={` ${this.props.color ? "white" : ""}`}>
                                    Compare deals on Booking.com
                                </label>
                            </div>
                            <div className="hottub_box">
                                <input id="hottub" type="checkbox" name="hottub" checked={this.state.hot_tub} readOnly/>
                                <span className="checkbox" onClick={this.checkHottub}>
                                    <svg viewBox="0 0 512 512">
                                        <path d="m187 434l-173-166 48-47 125 120 263-252 48 46z"></path>
                                    </svg>
                                </span>
                                <label htmlFor="hottub" onClick={this.checkHottub} className={` ${this.props.color ? "white" : ""}`}>
                                    Show me only properties with hot tubs
                                </label>
                            </div>
                        </div>
                        <div className="snaptrip_box">
                            <div className="thrv_wrapper thrv_text_element">
                                <p className={` ${this.props.color ? "white" : ""}`}>Powered by</p>
                            </div>
                            <svg viewBox="0 0 139.72 54.75">
                                <g fill={` ${this.props.color ? "#fff" : "#000"}`}>
                                    <path d="M78.74,20.75l-.11-.05a4.46,4.46,0,0,0-4.19.42,10.66,10.66,0,0,0-3.74,4.94c-.21.46-.41.94-.61,1.43,0-.19.27-.88.28-1.06,0,0,1.66-5.76.52-6.24A2.21,2.21,0,0,0,68,20.8a13.15,13.15,0,0,0-1.48,4.67c-.12,1.28-.34,2.73-.42,4.53a11.07,11.07,0,0,1-.6,1,9.77,9.77,0,0,1-1.18,1.42,4.57,4.57,0,0,1-1.35,1,1,1,0,0,1-.83.11c-.68-.31-2-1.89.45-9.84A9,9,0,0,0,62.87,22a1.71,1.71,0,0,0-1.12-1.74,1.62,1.62,0,0,0-1.32-.17h0a7.19,7.19,0,0,0-4.79.45A15,15,0,0,0,50.91,24a29.32,29.32,0,0,0-2.21,2.72,20.57,20.57,0,0,0-1.83,3.11A14,14,0,0,0,45.81,33a5.91,5.91,0,0,0-.14,1.59c-1.08.74-1.66.59-1.84-.35-.1-.55-.17-1-.28-1.66a20.66,20.66,0,0,1-.26-2.13q-.09-1.14-.15-2.25a41.7,41.7,0,0,0-.43-4.2,3.73,3.73,0,0,0-1.78-2.87,2.46,2.46,0,0,0-1.38-.37,3.61,3.61,0,0,0-1.88.59,11.76,11.76,0,0,0-3.44,3.31L34,25l.24-.92c.23-.86.27-.88.48-1.51a1.34,1.34,0,0,1,.38-.7,1.91,1.91,0,0,0,0-2.58,1.83,1.83,0,0,0-2.78-.18,4.09,4.09,0,0,0-.82,1.14,5.25,5.25,0,0,0-.7,1.71c-.12.41-.24.57-.38,1.09L30,24.74,29.2,28.1c-.32,1.39-.67,3-1,4.77-.18.63-.33,1.17-.42,1.63l-.19.94c-.51,2.27,0,2.92,1.13,3.21A2,2,0,0,0,31,37.41c.21-.4.67-1.06,1.25-2.12.39-.73.94-1.68,1.64-2.83s1.44-2.32,2.2-3.45,1.51-2.13,2.23-3,.77-.69.82,1.19c0,.46.08.87.09,1.27q.09,1.35.21,2.7c.16,1.67.29,6.9,2.77,8.11,1.69.83,4.89-1.27,4.89-1.27.86,1.21,4.2,1.13,7.8-1.34a21.53,21.53,0,0,0,3-2.53,4.9,4.9,0,0,0,2.74,2.94,4.42,4.42,0,0,0,3.73,0,9.58,9.58,0,0,0,1.42-.83l-.06.91-.59,15.67a1.34,1.34,0,0,0,.19,1l.11.15c.11.11.23.23.38.36a1.71,1.71,0,0,0,1.14.37A1.84,1.84,0,0,0,68.63,54a1.63,1.63,0,0,0,.3-.86l.84-7.52c.39-2.69.22-1.43.75-4.29a8,8,0,0,0,4.35-1.8,16.49,16.49,0,0,0,4.28-5.33,19,19,0,0,0,1.63-3.73,15.36,15.36,0,0,0,.69-3.76,8.29,8.29,0,0,0-.54-3.42A5,5,0,0,0,78.74,20.75ZM55.5,30.88c-1.81,2.24-3.38,3.58-4.77,4.07s-2.18-1.72,1.13-6a28.34,28.34,0,0,1,1.89-2.31,9.93,9.93,0,0,1,3.72-2.61c.08,0,1.39-.58,1.24.52A15.27,15.27,0,0,1,55.5,30.88Zm22.38-4a16.39,16.39,0,0,1-2.13,5.43,16.37,16.37,0,0,1-2.69,3.58,5.69,5.69,0,0,1-1.63,1.18c.29-1.24.59-2.43.91-3.58.43-1.57.89-3,1.35-4.23a16.5,16.5,0,0,1,1.5-3.09,5.26,5.26,0,0,1,1.49-1.66C77.66,23.83,78,25.82,77.88,26.86Z"></path>
                                    <path d="M99.22,20.86a5.81,5.81,0,0,0-4.08,1.76,14,14,0,0,0-1,1.13V23.6a6.45,6.45,0,0,0-.22-2,1.85,1.85,0,0,0-1-1.17,1.88,1.88,0,0,0-1.54,0,1.92,1.92,0,0,0-1,1A2,2,0,0,0,90.18,23a5.19,5.19,0,0,1,.11,1.76c0,1.11-.08,2.14-.19,3.56s-.22,2.66-.37,4-.28,2.48-.38,3.33a14.69,14.69,0,0,0-.16,1.54,2,2,0,0,0,1.89,2.41,1.67,1.67,0,0,0,1.44-.68,2.82,2.82,0,0,0,.44-.76,2.17,2.17,0,0,0,.12-.55,5,5,0,0,0,.21-1.22,5.72,5.72,0,0,1,.19-1.11c.26-1.11.6-2.32,1-3.58A24.84,24.84,0,0,1,96,28.2a11.24,11.24,0,0,1,1.74-2.55,2.07,2.07,0,0,1,1.51-.78,2,2,0,0,0,2-1.93,2.28,2.28,0,0,0-.45-1.43A1.69,1.69,0,0,0,99.22,20.86Z"></path>
                                    <path d="M106.48,29.39c.1-1.07.17-1.91.23-2.5a27.8,27.8,0,0,0,.28-2.82,1.89,1.89,0,0,0-.55-1.39,2,2,0,0,0-2.84-.07A2,2,0,0,0,103,24c0,.22,0,.54,0,1s-.08.92-.14,1.49c-.32,3.48-.5,6.23-.54,8.18,0,2.16.24,3.62,1,4.56a2.07,2.07,0,0,0,1.48.65,1.69,1.69,0,0,0,1.22-.4,1.8,1.8,0,0,0,.45-2.67,3.54,3.54,0,0,1-.15-1.29c0-.87,0-1.83.07-2.89S106.39,30.45,106.48,29.39Z"></path>
                                    <path d="M104.28,16.06a2.13,2.13,0,0,0-.7,1,1.68,1.68,0,0,0-.42,1.52,1.86,1.86,0,0,0,1.92,1.73h.23l.09,0a2.88,2.88,0,0,0,1-.37,2,2,0,0,0,.86-.91,1.93,1.93,0,0,0,.26-1,2.48,2.48,0,0,0-.5-1.44A1.84,1.84,0,0,0,104.28,16.06Z"></path>
                                    <path d="M124.47,23.88a5.12,5.12,0,0,0-2.31-2.61,4.46,4.46,0,0,0-4.19.42,10.73,10.73,0,0,0-3.74,4.94c-.21.47-.41.94-.6,1.44,0-.2,0-.38,0-.57a24.23,24.23,0,0,0,0-2.9,4.29,4.29,0,0,0-.37-2,1.75,1.75,0,0,0-.76-.7A1.78,1.78,0,0,0,111,21.8a2.05,2.05,0,0,0-1.1.84,1.92,1.92,0,0,0-.15,1.81c0,.26.08-.1,0,1.49,0,1.4-.13,3.12-.22,5.15l-.88,19.24,0,1a1.41,1.41,0,0,0,.2,1l.11.15c.11.11.23.23.37.35a1.76,1.76,0,0,0,1.15.37,1.85,1.85,0,0,0,1.74-.73,1.72,1.72,0,0,0,.3-.85l.09-1.14c.25-2.55.58-3.31,1-6.21.1-.69.14-1,.16-1.12a9.5,9.5,0,0,0,.26-1.29,8,8,0,0,0,4.35-1.8,16.67,16.67,0,0,0,4.29-5.34,18.88,18.88,0,0,0,1.62-3.72,14.62,14.62,0,0,0,.69-3.76,8.29,8.29,0,0,0-.53-3.42Zm-3,3.63a17.85,17.85,0,0,1-2.19,5.36h0a16.35,16.35,0,0,1-2.7,3.57A5.47,5.47,0,0,1,115,37.62c.29-1.25.59-2.44.9-3.58.43-1.55.89-3,1.36-4.22a16,16,0,0,1,1.5-3.1,5.09,5.09,0,0,1,1.49-1.65C121.13,24.45,121.8,25.74,121.48,27.51Z"></path>
                                    <path d="M133.91,4.32c-.24,1.17-.52,2.33-.75,3.51-.65,3.25-1.33,6.49-1.91,9.76-.52,2.91-1.52,8.84-1.95,11.62,0,.67-.05,1.2-.08,1.72a1,1,0,0,0,.49,1,1.72,1.72,0,0,0,2.66-1.11c.34-2.16,1.53-7.26,2.17-9.35,1.6-5.32,2.86-10.47,4.78-15.69C141.32.3,135.23-2,133.91,4.32Z"></path>
                                    <path d="M130.7,34a2.58,2.58,0,0,0-3.77.69,5.31,5.31,0,0,0-.73,2.46,3.94,3.94,0,0,0,2.15,3.5,2,2,0,0,0,1,.21,2.4,2.4,0,0,0,2-1.1,6.78,6.78,0,0,0,.64-1.33A4,4,0,0,0,130.7,34Z"></path>
                                    <path d="M108.89,8.76c-6.46.15-12.86.39-19.26.74l0-.16c.26-2,.45-3.42.56-4.36.16-1.35.19-.74.19-.92a1.88,1.88,0,0,0-.59-1.48,2,2,0,0,0-2.74,0A1.91,1.91,0,0,0,86.46,4c0,.09,0-.54-.22,1-.14,1.19-.3,2.56-.48,4.13l-.06.3,0,.33c-3.51.22-7,.46-10.54.75-2.59.22-3.86,4.34-.6,4.07,3.55-.3,7.09-.54,10.63-.76-.57,4.76-1.08,9.17-1.54,13.28-.5,4.49-.45,4.5-.78,7.81-.52,5.23,1.78,6,3.36,6A.84.84,0,0,0,87,39.73c-.5-1.24-.35-3.3,0-6.27.27-2.62.36-3.74.66-6.43s.59-5.31.89-7.86c.24-2.07.45-3.93.65-5.61,6.38-.35,12.75-.59,19.18-.74C110.91,12.76,112.15,8.69,108.89,8.76Z"></path>
                                    <path d="M18.15,18.29c-5.16-3.82-6-4.26-5.86-6.72.16-3.21,4.79-7.33,12.25-7.21,8.83.15,13,2.84,13,4.56,0,1.42-1.4,1.43-4.08,2-.66.15-2.14.72-2,2,.17,2.21,7.5,1.62,9.61-1C46.16,5.74,34.54,1.16,29.33.42c-9.52-1.35-14.88.74-18.42,4s-7.22,10.25,2,15.85c6.72,4.55,9.19,7,9,11.63-.28,6.39-8.16,7.46-10.42,7.54a7.54,7.54,0,0,1-5.93-2c-2.35-2.72-.11-7.16,5.79-7.38a1.55,1.55,0,0,0,1.59-1.36c0-.44-.26-1.55-3.15-2.15-2.08-.42-5.78,1.08-8,4-1.95,2.6-2.5,6.07-.87,8.64C5,45.53,16.62,44.74,21.32,41.5c.74-.52,4.72-3.23,5.41-8.09C27.86,25.42,22.64,21.62,18.15,18.29Z"></path>
                                </g>
                            </svg>
                        </div>
                    </div>
                    { this.props.scrollToForm && <ScrollButton ref={this.fixedRef} onClick={this.scrollToform}>
                        <svg fill="#000000" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 30 30" width="30px" height="30px"><path d="M 13 3 C 7.4889971 3 3 7.4889971 3 13 C 3 18.511003 7.4889971 23 13 23 C 15.396508 23 17.597385 22.148986 19.322266 20.736328 L 25.292969 26.707031 A 1.0001 1.0001 0 1 0 26.707031 25.292969 L 20.736328 19.322266 C 22.148986 17.597385 23 15.396508 23 13 C 23 7.4889971 18.511003 3 13 3 z M 13 5 C 17.430123 5 21 8.5698774 21 13 C 21 17.430123 17.430123 21 13 21 C 8.5698774 21 5 17.430123 5 13 C 5 8.5698774 8.5698774 5 13 5 z"/></svg>
                        <span>Take me to Search</span>
                    </ScrollButton>}
                    </Container>
                </div>
            </Styles>
            </Section>
        )
    }
}

export default SearchForm;